/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
export const validateMobileReg = value => /^1[3|4|5|6|7|8|9]\d{9}$/.test(value);

// 校验手机号
export const validateMobile = (rule, value, callback) => {
  if (rule.isEmpty && (value === '' || !value)) {
    callback();
    return;
  }
  if (!rule.isEmpty && value === '') {
    callback(new Error(`请输入${rule.name}`))
  } else if (!/^1[3|4|5|6|7|8|9]\d{9}$/.test(value)) {
    callback(new Error(`请输入正确的${rule.name}`))
  } else {
    callback()
  }
}
// 校验联系方式
export const validateContacts = (rule, value, callback) => {
    if(rule.isEmpty && (value === '' || !value)){
        callback();
        return;
    }
    if(!rule.isEmpty && value === ''){
        callback(new Error(`请输入联系方式`))
    }
    else if(!/^\d{7,15}$/.test(value) && !/^((0\d{2,3})-)?(\d{7,10})$/.test(value)){
        callback(new Error(`请输入正确的${rule.name}`))
    }
    else{
        callback()
    }
}

// 用户名检验
export const validateUserName = (rule, value, callback) => {
  if (!value || value === '') {
    callback(new Error(`请输入${rule.name}`))
  } else if (!/^[A-Za-z\u4e00-\u9fa5]{1,20}$/.test(value)) {
    callback(new Error(`请输入1-20位汉字字母组合的${rule.name}`))
  } else {
    callback()
  }
}

// 校验纯汉字
export const validateChat = (rule, value, callback) => {
  if (rule.isEmpty && (value === '' || !value)) {
    callback();
    return;
  }
  if (!rule.isEmpty && value === '') {
    callback(new Error(`请输入${rule.name}`))
  } else if (!/^[\u4e00-\u9fa5]+$/.test(value)) {
    callback(new Error(`请输入汉字类型的${rule.name}`))
  } else if (rule.maxLength && value.length > rule.maxLength){
    callback(new Error(`${rule.name}最多只能输入${rule.maxLength}个字`))
  } else {
    callback()
  }
}

// 校验邮箱格式
export const validateEmail = (rule, value, callback) => {
  if (rule.isEmpty && (value === '' || !value)) {
    callback();
    return;
  }
  if (!rule.isEmpty && value === '') {
    callback(new Error(`请输入${rule.name}`))
  } else if (!/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(value)) {
    callback(new Error(`请输入正确的${rule.name}`))
  } else if (value.length > 50){
    callback(`${rule.name}不能超过50个字符大小`)
  } else {
    callback();
  }
}

// 校验备注
export const validatRemark = (rule, value, callback) => {
  if (rule.isEmpty && (value === '' || !value)) {
    callback();
    return;
  }
  if (!rule.isEmpty && value === '') {
    callback(new Error(`请输入${rule.name}`))
  } else if (value.length < 2) {
    callback(new Error(`${rule.name}不少于2个字符`))
  } else {
    callback()
  }
}

/**
*  校验密码规则：大小写字母+数字，小于25个字符
*  @param {Function} rule.compareData： 返回进行对比的值
*  @param {String} rule.result 提示名称
*/
export function validatePassword (rule, value, callback) {
  if (rule.isEmpty && (value === '' || !value)) {
    callback();
    return null;
  }
  const data =value.replace(/(^\s*)|(\s*$)/g, '')
  const compare = rule.compareData ? rule.compareData() : true
  if (!data || data === '') {
    callback(new Error(`请输入${rule.result}`))
  } else if (!/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9-_+=*&^%$#@!]{6,25})$/.test(data)) {
    callback(new Error(`请输入6-25个字母加数字组合的${rule.result}`))
  } else if (!compare){
    callback(`两次输入的${rule.result}不一致`)
  } else {
    callback()
  }
}

export function validateMoney (rule, value, callback) {
  if (rule.isEmpty && !(!!value)) callback();
  else if (!rule.isEmpty && !(!!value)) callback(`请输入${rule.name}`);
  else if (!/(^[0-9]{0,9}$)|(^[0-9]{1,9}[\.]{1}[0-9]{1,2}$)/.test(value)) callback(`${rule.name}为小于999999999.99的数值类型`);
  else callback();
}

 /**
  * 验证数字
  * @param {String} rule.result 提示名称
  * @param {Integer} rule.type 文本校验类型 1:正整数 2:负整数 3:正数(带两位小数) 4:负数(带两位小数)
  * @param {Integer} rule.min 最小位数
  * @param {Integer} rule.max 最大位数
  * @param {Integer} rule.len 最大长度
  * @param {Boolean} rule.isEmpty 是否允许为空
  */
 export function validateNumber (rule, value, callback) {
  const { type, min, max, len, isEmpty } = rule
  if (isEmpty && value === '') callback()
  const data =value.toString().replace(/(^\s*)|(\s*$)/g, '');
  if (data.length > len) callback(new Error(`请输入的数值在${len}位数以内`))
  if (type === 1 && !/^[0-9]+$/.test(data)) callback(new Error(`请输入正确的正整数`))
  else if (type === 2 && !/^\-[0-9]+$/.test(data)) callback(new Error(`请输入正确的负整数`))
  else if (type === 3 && !/^[0-9]+(\.?[0-9]{0,2})$/.test(data)) callback(new Error(`请输入最多两位小数的数字`))
  else if (type === 4 && !/^\-[0-9]+(\.?[0-9]{0,2})$/.test(data)) callback(new Error(`请输入最多两位小数的数字`))

  if ((min && max) && (data < min || data > max) ) callback(new Error(`请输入数值在${min}到${max}之间的${rule.result}`))
  else if (min && data < min) callback(new Error(`请输入数值最小为${min}的${rule.result}`))
  else if (max && data > max) callback(new Error(`请输入数值最大为${max}的${rule.result}`))
  else callback()
}
